'use client';

import React from 'react';
import { Box, Typography, Paper, Fade, Button, Grid } from '@mui/material';
import SavedQuantitiesGrid from '../../components/Estimator/SavedQuantitiesGrid';
import PipeSpecsGrid from '../../components/Estimator/PipeSpecsGrid';
import CostAssumptionsGrid from './CostAssumptions';
import StandardWallThicknessGrid from './StandardWallThicknessGrid';
import SpecialItemsGrid from './SpecialItemsGrid';
import CostCategorySummaryGrid from './CostCategorySummary';
import { useEstimator } from '../../context/EstimatorContext';
const PMInputs = ({ onComplete }) => {
  const { formData, setFormData } = useEstimator();

  const handleNext = () => {
    onComplete();
  };

  console.log(formData);

  return (
    <Fade in>
      <Box display="flex" flexDirection="column" gap={3} mt={4}>
        <Paper
          elevation={1}
          sx={{
            p: 3,
            backgroundColor: '#F9F9F9',
            borderRadius: 2,
            borderLeft: '4px solid #223A64',
          }}
        >
          <SavedQuantitiesGrid />
        </Paper>

        <Paper
          elevation={3}
          sx={{
            p: 3,
            backgroundColor: '#F9F9F9',
            borderRadius: 2,
            borderLeft: '4px solid #A7B9D1',
            height: '100%',
          }}
        >
          <CostAssumptionsGrid />
        </Paper>

        <Paper
          elevation={3}
          sx={{
            p: 3,
            backgroundColor: '#F9F9F9',
            borderRadius: 2,
            borderLeft: '4px solid #5A7AA1',
            height: '100%',
          }}
        >
          <StandardWallThicknessGrid />
        </Paper>

        <Paper
          elevation={3}
          sx={{
            p: 3,
            backgroundColor: '#F9F9F9',
            borderRadius: 2,
            borderLeft: '4px solid #0C1D3C',
          }}
        >
          <PipeSpecsGrid />
        </Paper>

        <Paper
          elevation={3}
          sx={{
            p: 3,
            backgroundColor: '#F9F9F9',
            borderRadius: 2,
            borderLeft: '4px solid #8CA3C4',
          }}
        >
          <SpecialItemsGrid />
        </Paper>
        <Paper
          elevation={3}
          sx={{
            p: 3,
            backgroundColor: '#F9F9F9',
            borderRadius: 2,
            borderLeft: '4px solid #3A5B8A',
          }}
        >
          <CostCategorySummaryGrid />
        </Paper>

        <Box display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={handleNext}>
            Next
          </Button>
        </Box>
      </Box>
    </Fade>
  );
};

export default PMInputs;
